export default __webpack_public_path__ + "static/histogram-with-specified-bins-fa437e38bae342056e4f4be6266c24f3.png";